import HomePage from '@/features/home';

export default function LandingPage() {
  return <HomePage />;
}
